<template>
  <div class="box">
    <van-checkbox-group
      class="checkbox_group"
      v-model="result"
      v-for="(item,index) in food"
      :key="index"
    >
      <van-checkbox @click="checkboxClick(item)" class="checkbox_text" :name="item.id"></van-checkbox>
      <div class="food">
        <div class="img">
          <img :src="baseURL + item.picture" />
        </div>
        <div class="title">
          <div class="name">
            {{item.name}}
            <p>￥ {{item.price*item.num}}</p>
          </div>
          <p class="specs">{{item.specs}}</p>
          <p class="num">
            {{item.price}}
            <van-stepper
              theme="round"
              button-size="22"
              disable-input
              v-model="item.val"
              :max="item.num"
            />
          </p>
        </div>
      </div>
    </van-checkbox-group>
    <div class="btn">
      <van-button @click="sureBtn" round block type="danger" native-type="submit">确认退款</van-button>
    </div>
  </div>
</template>
<script>
import Config from "@/config";
import { Notify, Toast, Popup } from "vant";
import { Dialog } from "vant";
export default {
  data() {
    return {
      result: [],
      food: [],
      id: "",
      baseURL: Config.baseURL,
      value: "",
    };
  },
  mounted() {
    console.log(this.$route.query);
    this.id = this.$route.query.id;
    this.food = JSON.parse(this.$route.query.obj);
    this.food.forEach((item) => {
      console.log(item.num);
      Object.assign(item, { val: item.num });
    });
    console.log(this.food);
  },
  methods: {
    checkboxClick(item) {
      console.log(item);
    },
    sureBtn() {
      console.log(this.result);
      console.log(this.food);
      let add = [];
      this.food.forEach(item=>{
        // console.log('=====',item)
        this.result.forEach(its=>{
            // console.log('-----',its)
            if(item.id == its){
                console.log()
                add.push({
                    id:its,
                    num:item.val
                })
            }
        })
      })
      console.log(add)
      Dialog.confirm({
        title: "提示",
        message: "请确认是否要退款？",
      }).then(() => {
        this.$http
          .post("/wechat/api.order/partRefund", {
            id: this.id,
            ids: add,
          })
          .then((response) => {
            if (response && response.data.code == 200) {
              Notify({ type: "success", message: response.data.msg });
              this.$router.go(-1);
            } else {
              Notify({ type: "danger", message: response.data.msg });
            }
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 15px;
}
/deep/ .van-checkbox__label {
  width: 80%;
}
.checkbox_group {
  display: flex;
}
.checkbox_text {
  font-size: 0.4rem;
}
.food {
  width: 80%;
  margin: 0.14rem 0.42667rem;
  font-size: 0.4rem;
  display: flex;
}
.food p {
  padding: 0;
  margin: 0;
}
.food img {
  width: 2rem;
  height: 100%;
  border-radius: 0.1rem;
}
.food .title {
  flex: 1;
  margin-left: 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.food .name {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.food .num {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.food .title .num,
.food .title .specs {
  font-size: 0.3rem;
  color: #999;
}
.btn {
  margin-top: 20px;
}
</style>